import { motion } from "framer-motion";
import styled from "styled-components";
import { sizing } from "../../../styles/variables.js";

export const AboutWrapper = styled.div`
   display: flex;
   margin-top: 2rem;

   @media (max-width: 1100px) {
      margin-top: 0.4rem;
      flex-direction: column-reverse;
   }
`;

export const AboutText = styled.div`
   flex: 1;
   margin-right: 2rem;

   @media (max-width: 900px) {
      margin-right: 0;
   }

   p {
      font-size: 1.1rem;
   }
`;

export const AboutSkills = styled.div`
   flex: 1;
`;

export const Illustration = styled(motion.div)`
   flex: 1;

   @media (max-width: 1100px) {
      max-width: 500px;
      margin: 0 auto 1.4rem;
   }

   .image {
      width: 100%;
      height: auto;
      margin: 0 auto;
      transform: scale(1.2);
   }
`;

export const SkillCard = styled.div`
   padding: 1rem 1.4rem;
   margin-bottom: 1rem;
   border-radius: 0 ${sizing.borderRadius1} ${sizing.borderRadius1};
   box-shadow: 0 4px 16px #efefef;

   @media (max-width: 900px) {
      width: 90%;
      max-width: 28rem;
   }

   @media (max-width: 500px) {
      width: 95%;
   }
`;
